import { alpha, styled, ToggleButtonGroup } from '@mui/material';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '6px',
  backgroundColor: theme.palette.background.paper,
  padding: 0,
  gap: 0,
  '& .MuiToggleButton-root': {
    border: 'none',
    borderRadius: 0,
    padding: '6px 12px',
    minWidth: '40px',
    color: theme.palette.text.secondary,
    transition: 'all 0.2s ease-in-out',
    '&:first-of-type': {
      borderTopLeftRadius: '6px',
      borderBottomLeftRadius: '6px',
    },
    '&:last-of-type': {
      borderTopRightRadius: '6px',
      borderBottomRightRadius: '6px',
    },
    '&:not(:last-of-type)': {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.primary, 0.04),
      color: theme.palette.text.primary,
    },
    '&.Mui-selected, &.Mui-selected:focus': {
      backgroundColor: `${alpha(theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main, 0.08)} !important`,
      color: `${theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main} !important`,
      '&:hover': {
        backgroundColor: `${alpha(theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main, 0.12)} !important`,
      },
    },
  },
}));

